import { isSandboxHost } from "@/lib/runtime-env";

/** Visible chrome so a sandbox tab next to production is obvious. */
export function SandboxBanner() {
  if (!isSandboxHost()) return null;
  return (
    <div
      role="status"
      className="bg-amber-500 px-4 py-1.5 text-center text-xs font-semibold text-amber-950"
    >
      Sandbox — DIAN HAB only, no billing. This is not production.
    </div>
  );
}
